import React from 'react'
import { Chip } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const useStyles = makeStyles()(theme => ({
  chip: {
    height: '26px',
    width: 'max-content',
  },
  allWallboxes: {
    backgroundColor: theme.palette.chargingCard.status.active.background,
    color: theme.palette.chargingCard.status.active.text,
  },
  noWallboxes: {
    backgroundColor: theme.palette.chargingCard.status.rejected.background,
    color: theme.palette.chargingCard.status.rejected.text,
  },
}))

interface ChargingCardLinkedWallboxesChipProps {
  cardUsability: 'allWallboxes' | 'noWallboxes'
}

/**
 * Component for displaying different type of chips for linked card with wallboxes
 * Chips are displayed based on logic explained inside LinkedWallboxesCell
 */
export const ChargingCardLinkedWallboxesChip: React.FunctionComponent<ChargingCardLinkedWallboxesChipProps> = ({ cardUsability }) => {
  const { classes, cx } = useStyles()
  const { t } = useCustomTranslation()

  if (cardUsability === 'noWallboxes') {
    return <Chip label={t('emobility.chargingCards.no-wallboxes')} className={cx(classes.chip, classes.noWallboxes)} />
  }

  return <Chip label={t('emobility.chargingCards.all-wallboxes')} className={cx(classes.chip, classes.allWallboxes)} />
}
